import { Suspense, useEffect, useState } from "react";
import Loading from "../../../../common/components/ui/loading/Loading";
import GenericTable from "../../../../common/components/ui/table/GenericTable";
import { TableFilters, TableFiltersState } from "../../../../common/components/ui/table/TableFilters";
import { emptyPurchaseReturn, IPurchaseReturn } from "@/types/purchase-return.type";
import ModalCreatePurchaseReturn from "../modals/Modal-create-purchase-return";
import { getPurchaseReturns } from "@/common/services/purchase-return.api";
import TableFooter from "@/common/components/ui/table/TableFooter";
import { useNavigate } from "react-router-dom";

function TablePurchaseReturn() {
  const [totalItems, setTotalItems] = useState(0);
  const [purchaseReturn, setPurchaseReturn] = useState<IPurchaseReturn[]>([]);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState<TableFiltersState>({
    search: "",
    status: []
  });

  const [page, setPage] = useState<number>(1);
  const [action, setAction] = useState({ eventName: '', data: emptyPurchaseReturn() });

  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      setIsLoading(true);
      const response = await getPurchaseReturns({
        ...filters,
        itemsPerPage: String(itemsPerPage),
        status: filters.status as never[]
      });
      setIsLoading(false);

      setPurchaseReturn(response.data);
      setTotalItems(response.totalItems);
    }

    load();
  }, [action, filters, itemsPerPage]);

  const STATUS_LABELS = {};

  const actions = [
    {
      label: "Visualizar",
      permission: "edit:inventory-pieces",
      action: (data: unknown) => {
        setAction({ eventName: 'view', data: data as IPurchaseReturn });
      },
    },
  ];

  return (
    <Suspense fallback={<Loading />}>
      <div
        className="pt-4 px-4 flex flex-col bg-white text-black dark:text-black flex-grow overflow-hidden h-full"
        style={{ maxHeight: 'calc(100vh - 50px)', minHeight: '40px' }}
      >

        <TableFilters
          dashboardHeader="Devoluções de Compra"
          placeholder="Digite a descrição da OC..."
          statusOptions={STATUS_LABELS}
          newItemLabel="Nova Devolução"
          onNewItemClick={() => setAction({ eventName: 'create', data: emptyPurchaseReturn() })}
          hideStatusFilter
          onSearch={(data) => setFilters((prevFilters) => ({ ...prevFilters, ...data }))}
          tableData={[]}
          entity="purchase-order"
          reservationDays={itemsPerPage}
          setReservationDays={setItemsPerPage}
        />

        <GenericTable
          headers={{
            createdAt: 'Data',
            returnRequestor: "Solicitante",
            purchaseOrderDescription: "Descrição da OC",
          }}
          actions={actions}
          data={purchaseReturn}
          renders={{
            returnRequestor: (data: unknown) => <p>{String(data)}</p>,
            purchaseOrderDescription: (data: unknown, el) => <a onClick={() => {
              navigate(`${(el as IPurchaseReturn).purchaseOrderId}`);
            }}
              className="cursor-pointer">{String(data)}</a>,
            createdAt: (data: unknown) => <p>{new Date(data as Date).toLocaleDateString("pt-BR")}</p>
          }}
        />
        {isLoading && <Loading />}

        <TableFooter page={page || 1}
          totalItems={totalItems}
          itemsPerPage={+(filters.itemsPerPage ?? 10)}
          goToPage={setPage}
        />
      </div>
      {action.eventName === 'create' && <ModalCreatePurchaseReturn onClose={() => setAction({ eventName: '', data: emptyPurchaseReturn() })} opened={true} />}
    </Suspense>
  );
}

export default TablePurchaseReturn;
